module.exports = __webpack_public_path__ + "static/media/sn.bcaa9136.webp";